import { TableCellProps, TableRowProps } from "@mui/material";
import UserStorage from "../cache/UserStorage";
import { MutableRefObject, ReactElement } from "react";
import { IGWidgetProps } from "../widgets/IGWidget";

export type TRenderData = {[key:string]:any}
export type TCellType = JSX.Element | string | number;
export type TTHRenderer = (col:string, sort:string, dir:number, data:TRenderData|undefined) => JSX.Element|string|number;
export type TTHCellProps = (col:string, sort:string, dir:number, data:TRenderData|undefined) => TableCellProps;
export type TRowProps<T> = (row:T, data:TRenderData|undefined, ref:MutableRefObject<any>) => TableRowProps&IGWidgetProps;
export type TCellRenderer<T> = (row:T, col:string, data:TRenderData|undefined) => TCellType
export type TCellProps<T> = (row:T, col:string, data:TRenderData|undefined) => TableCellProps;
export type TSort = [string,number];
export type TOnPage = (page:number) => void;
export type TOnSort = (col:string,dir:number) => void;
export type TSortPred<T> = (left:T,right:T) => number;
export type TSorter<T> = (col:string,dir:number) => TSortPred<T>

export const SORT_COL = "tsort";

export interface IGTableProps<T> extends IGWidgetProps{
    tableName:string;
    cols:string[];
    rows:T[];
    footers?:T[];
    children?:ReactElement

    // any data that's passed to renderer
    data?:TRenderData;

    // get column label
    label?:(col:string) => JSX.Element|string;
    // get cell value
    value?:(row:T, col:string) => string|number;
    footerValue?:(row:T, col:string) => string|number;

    // override header cell
    headerCell?:TTHRenderer;
    headerCellProps?:TTHCellProps;

    // override body row/cell
    rowKey?:(row:T) => string;
    bodyRowProps?:TRowProps<T>;
    bodyCell?:TCellRenderer<T>;
    bodyCellProps?:TCellProps<T>;
    onRowMount?:(row:T, ref:MutableRefObject<any>) => void;
    onRowUnmount?:(row:T, ref:MutableRefObject<any>) => void;

    // override footer row/cell
    footerRowProps?:TRowProps<T>;
    footerCell?:TCellRenderer<T>;
    footerCellProps?:TCellProps<T>;

    // sort
    disableSort?:boolean        // false by default
    customSort?:boolean;
    sorter?:TSorter<T>
    sort?:string|TSort;
    onSort?:TOnSort;
    userPref?:UserStorage<any>;

    // pagination
    page?:number;
    rowsPerPage?:number;
    onPage?:TOnPage;

    // inifinite scroll
    infiniteScroll?:boolean
    onScroll?:(index:number) => void
}
